var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgX = function SvgX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.355 13.239c.01.142.01.284.01.426 0 4.335-3.299 9.33-9.33 9.33A9.266 9.266 0 0 1 8 21.523c.264.03.518.04.792.04a6.567 6.567 0 0 0 4.07-1.4 3.285 3.285 0 0 1-3.065-2.275c.203.03.406.051.62.051.294 0 .588-.04.862-.112a3.28 3.28 0 0 1-2.63-3.218v-.04c.437.243.945.395 1.483.416a3.277 3.277 0 0 1-1.462-2.731c0-.61.162-1.168.447-1.655a9.32 9.32 0 0 0 6.761 3.431 3.702 3.702 0 0 1-.081-.75 3.278 3.278 0 0 1 3.28-3.28c.943 0 1.796.396 2.395 1.036a6.455 6.455 0 0 0 2.081-.792 3.27 3.27 0 0 1-1.441 1.807c.66-.071 1.3-.254 1.888-.508a7.048 7.048 0 0 1-1.645 1.696z",
    fillRule: "nonzero"
  })));
};
export default SvgX;